import { Pathways } from "./grpc/pathway_pb";
// maps pathway names to their ids
// from the enum in src/grpc/pathway_pb.js
const pathwayIds = {
  Aerospace: "AEROSPACE",
  "Agriculture, Food and Natural Resources": "AGRICULTURE",
  "Architecture and Construction": "ARCHITECTURE",
  "Arts, Audio/Visual Technology and Communications": "ARTS",
  "Business Management and Administration": "BUSINESS",
  "Education and Training": "EDUCATION",
  Engineering: "ENGINEERING",
  Energy: "ENERGY",
  Finance: "FINANCE",
  "Government and Public Administration": "GOVERNMENT",
  "Health Sciences": "HEALTH",
  "Hospitality and Tourism": "HOSPITALITY",
  "Human Services": "HR",
  "Information Technology": "IT",
  "Law, Public Safety, Corrections and Security": "LAW",
  Manufacturing: "MANUFACTURING",
  Marketing: "MARKETING",
  "Transportation, Distribution and Logistics": "TRANSPORTATION",
};

export const getPathwayId = (pathwayName) => {
  for (const [key, value] of Object.entries(pathwayIds)) {
    if (pathwayName.toLowerCase() === key.toLowerCase()) {
      return value;
    }
    // if (pathwayName.toLowerCase().includes(value.toLowerCase())) {
    //   return value;
    // }
  }

  throw new Error(`Pathway name ${pathwayName} not found in enum`);
};

// should pass the enum number for pathways in the pathway_pb.js file
export const getPathwayName = (pathwayId) => {
  for (const [key, value] of Object.entries(pathwayIds)) {
    if (value.toLowerCase() === getPathwayIdByValue(pathwayId)?.toLowerCase()) {
      return key;
    }
  }
};

// dealing with the psuedo enum in src/grpc/pathway_pb.js
export const getPathwayIdByValue = (value) => {
  return Object.keys(Pathways).find((key) => Pathways[key] === value);
};

export const getUserTypeId = (userType) => {
  switch (userType.toLowerCase()) {
    case "student":
      return 0;
    case "parent":
      return 1;
    case "teacher":
      return 2;
    case "citizen":
      return 3;
    default:
      return 0;
  }
};

export const getUserTypeName = (userTypeId) => {
  switch (userTypeId) {
    case 0:
      return "Student";
    case 1:
      return "Parent";
    case 2:
      return "Teacher";
    case 3:
      return "Citizen";
    default:
      return "Student";
  }
};

export const getGradeEnumValue = (grade) => {
  switch (grade) {
    case "7":
      return 0;
    case "8":
      return 1;
    case "9":
      return 2;
    case "10":
      return 3;
    case "11":
      return 4;
    case "12":
      return 5;
    default:
      return 0;
  }
};

export const getGradeFromEnumValue = (gradeEnumValue) => {
  switch (gradeEnumValue) {
    case 0:
      return "7";
    case 1:
      return "8";
    case 2:
      return "9";
    case 3:
      return "10";
    case 4:
      return "11";
    case 5:
      return "12";
    default:
      return "7";
  }
};
